import { EngagementErrorDialogDataModel } from './engagement-error-dialog-data.model';

export class EngagementDocumentUpdatedStrategyModel implements EngagementErrorDialogDataModel {

  engagementId: number;

  constructor(engagementId: number) {
    this.engagementId = engagementId;
  }

  getTitle() { return 'Another signer is currently signing this engagement, and only one person can sign at a time. Please refresh the page and return to complete signature.'; }
  getMessage() { return ''; }
  getImagePath() { return 'out-of-date.png'; }
  getButtonText() { return 'Refresh'; }
  getRoutePath() { return ''; }
}
